import $axios from './axios-instance.js';
import { Promise } from "es6-promise";
import $router from '../routes';
import { GETTOKENS } from '../store/token/action.type'
import store from '../store'
import { SET_USER_LOGGED, REMOVE_USER_DETAILS } from '../store/auth/action.type'
export default () => {

  $axios.interceptors.request.use((config) => {
    const token = localStorage.getItem('GiftRegistryAccessToken'+ process.env.VUE_APP_ACCESS_TOKEN_NAME)
    // console.log("FAFASFASDFASFASF"); console.log(token)
    if (token) {
      config.headers.Authorization = token;
    }
    return config;
  });

  $axios.interceptors.response.use( (response) => {
    // Return a successful response back to the calling service
    return response;

  }, (error) => { 
    console.log(error)
    // Return any error which is not due to authentication back to the calling service
    if (error.response.status !== 401) {
      return new Promise((resolve, reject) => {
        reject(error);
      });
    }
    //return error if
    if (error.config.url == process.env.VUE_APP_BASE_API_URL+'/auth/login' && error.response.status !== 200) {
      return new Promise((resolve, reject) => {
        
        reject(error);
      });
    }


    // Logout user if token refresh didn't work or user is disabled
    if (error.config.url == process.env.VUE_APP_BASE_API_URL+'/auth/token' || error.response.status == 401) {
      console.log(error.config)
      localStorage.clear();
      $router.push({ name: 'Login'});
      return new Promise((resolve, reject) => {
        reject(error);
      });
    }

    // Try request again with new token
    return store.dispatch(GETTOKENS)
    .then((token) => {
      console.log(token.headers)
      // console.log(token.data.data.tokenData.accessToken)
      // localStorage.setItem('GiftRegistryAccessToken'+ process.env.VUE_APP_ACCESS_TOKEN_NAME,token.data.data.tokenData.accessToken)
      // localStorage.setItem('GiftRegistryRefreshToken'+ process.env.VUE_APP_ACCESS_TOKEN_NAME,token.data.data.tokenData.refreshToken)

      localStorage.removeItem('GiftRegistryAccessToken'+ process.env.VUE_APP_ACCESS_TOKEN_NAME);
      localStorage.removeItem('GiftRegistryRefreshToken'+ process.env.VUE_APP_ACCESS_TOKEN_NAME)
      localStorage.setItem('GiftRegistryAccessToken'+ process.env.VUE_APP_ACCESS_TOKEN_NAME,token.headers.accesstoken)
      localStorage.setItem('GiftRegistryRefreshToken'+ process.env.VUE_APP_ACCESS_TOKEN_NAME,token.headers.refreshtoken)
        // New request with new token
        const config = error.config;
        config.headers['Authorization'] = localStorage.getItem('GiftRegistryAccessToken'+ process.env.VUE_APP_ACCESS_TOKEN_NAME);

        return new Promise((resolve, reject) => {
          $axios.request(config).then(response => {
            resolve(response);
          }).catch((error) => { 
            reject(error);
          })
        });

      })
      .catch((error) => {
        return new Promise((resolve, reject) => { 
          reject(error);
        });
      });
  });
}
